import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../services/validation-service/validation.service";
import {LeadService} from "../../../services/lead-service/lead.service";
import {ErrorMessages} from "../../../model/ErrorMessages";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {GetListsResponse} from "../../../model/GetListsResponse";
import {VehicleSearchRegVinResponse} from "../../../model/VehicleSearchRegVinResponse";
import {VehicleItem} from "../../../model/VehicleItem";
import {QuoteResponse} from "../../../model/QuoteResponse";
import {WebLeadType} from "../../../model/leads/WebLeadType";

declare var $: any;
declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-quote-step-two',
  templateUrl: './quote-step-two.component.html'
})
export class QuoteStepTwoComponent implements OnInit, AfterViewInit {

  showSearchByRegOrVin = true;
  showSmartSearch = false;
  showVehicleResult = false;
  showParkingQuestions = false;
  showMainDriverDetails = false;
  searching = false;

  vehicle: VehicleItem = {itemDescription: null, vehicleRegistrationNo: null, itemTypeCd: 1, modelRangeYearCd: null};

  errorMessage = ErrorMessages;
  showSpinner = false;
  searchType: string;
  vehicleNotFoundByRegOrVin = false;
  loadingQuote = false;
  @ViewChild('formStart') formStart: ElementRef;

  readonly invalidQuoteStatusCd = 36;
  readonly indicativeQuoteStatusCd = 28;
  readonly licenseDetailsNotFoundErrorCd = 7;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService,
              private leadService: LeadService,
              private gtmService: GtmService) { }

  ngOnInit() {
    this.quotationService.loadScreen('aboutYourVehicle').subscribe((response: GetListsResponse) => {
      this.quotationService.parkingSecuritySelectItemList = response.parkingSecuritySelectItemList;
      this.quotationService.driversLicenseTypeSelectItemList = response.driversLicenseTypeSelectItemList;
      this.quotationService.yearsAtPreviousInsurerSelectItemList = response.yearsAtPreviousInsurerSelectItemList;
      this.quotationService.genderSelectItemList = response.genderSelectItemList;
    })
    this.reloadJCF();
  }

  ngAfterViewInit() {
    this.quotationService.scrollToPosition(this.formStart.nativeElement.getBoundingClientRect().top);
  }

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  get readyToSearch(): boolean {
    return (this.searchType === 'registration' && this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vehicleRegistrationNo != null) ||
      (this.searchType === 'vin' && this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vinNumber != null);
  }

  searchVehicleByRegOrVin() {
    this.searching = true;
    this.showSpinner = true;
    let vehicleSearchRequest = this.searchType === 'registration' ?
      {vehicleRegistrationNo: this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vehicleRegistrationNo} :
      {vinNumber: this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vinNumber};
    const gtmAction = this.searchType === 'registration' ? 'search_reg_your_vehicle_details' : 'search_vin_your_vehicle_details';
    this.gtmService.postGtmEvent('form_step_complete', gtmAction, 3);
    this.quotationService.searchVehicleByRegOrVin(vehicleSearchRequest).subscribe((response: VehicleSearchRegVinResponse) => {
      this.showSpinner = false;
      if (response.serviceResponseStatus === 'SUCCESS') {
        this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.modelRangeYearCd = response.vehicleItem.modelRangeYearCd;
        this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription = response.vehicleItem.itemDescription;
        this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vehicleRegistrationNo = response.vehicleItem.vehicleRegistrationNo;
        this.showSearchByRegOrVin = false;
        this.searching = false;
        this.showVehicleResult = true;
      } else {
        this.showSearchByRegOrVin = false;
        this.searching = false;
        this.showSmartSearch = true;
        this.vehicleNotFoundByRegOrVin = true;
      }
    }, error => {
      this.showSpinner = false;
      this.showSearchByRegOrVin = false;
      this.searching = false;
      this.showSmartSearch = true;
      this.vehicleNotFoundByRegOrVin = true;
    })
  }

  get vehicleDescription(): String {
    let vehicle = this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription;
    vehicle = vehicle.substr(0, vehicle.length-12);
    if (vehicle.substr(vehicle.length-4, vehicle.length).match(/\d+/g)) {
      vehicle = vehicle.substr(0, vehicle.length-4)
    }
    return vehicle;
  };

  rejectVehicleSearchResult() {
    this.reloadJCF();
    this.vehicle = {itemDescription: null, vehicleRegistrationNo: null, itemTypeCd: 1, modelRangeYearCd: null};
    this.showVehicleResult = false;
    this.showSearchByRegOrVin = true;
  }

  acceptVehicleSearchResult() {
    this.showVehicleResult = false;
    this.showParkingQuestions = true;
    this.leadService.leadComment += '|Vehicle:' + this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription;
    this.gtmService.postGtmEvent('form_step_complete', 'accept_vehicle_search_result', 3);
    this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
  }

  showSearchByMake() {
    this.gtmService.postGtmEvent('form_step_complete', 'search_model_your_vehicle_details', 3);
    this.showParkingQuestions = false;
    this.showSearchByRegOrVin = false;
    this.showVehicleResult = false;
    this.showSmartSearch = true;
  }

  backFromSmartSearch() {
    this.reloadJCF();
    this.showSearchByRegOrVin = true;
    this.showSmartSearch = false;
  }

  submitVehicleSmartSearchSelection() {
    this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.vehicleRegistrationNo = null;
    this.leadService.leadComment += '|Vehicle:' + this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription;
    this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
    this.showSmartSearch = false;
    this.showParkingQuestions = true;
  }

  backFromParkingQuestions() {
    this.reloadJCF();
    this.showMainDriverDetails = false;
    this.showParkingQuestions = false;
    this.showSearchByRegOrVin = true;
  }

  get readyToGetQuote(): boolean {
    const mainDriverDetailsValid = (this.validationService.isPrimaryDriverNameValid() &&
      this.validationService.isPrimaryDriverSurnameValid() &&
      this.validationService.isPrimaryDriverCellPhoneValid() &&
      (this.validationService.isPrimaryDriverIDValid() || (this.validationService.isPrimaryDriverPassportValid() &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.dateOfBirth <= this.quotationService.maxDateOfBirth &&
        this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.gender != null)) &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.yearsAtPreviousInsurerCd != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.consentGiven);
    const licenseDetailsValid = this.quotationService.captureLicenseDetails === true ?
      (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.driverLicenseDetail.driversLicenseTypeList[0].licenseTypeCd != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.driverLicenseDetail.driversLicenseTypeList[0].licenseIssueDate != null) : true;

    return this.vehicle && this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.suburbCd &&
      this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.addressSecurityCd && licenseDetailsValid &&
      (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.planHolder || mainDriverDetailsValid);
  }

  getQuote() {
    this.showSpinner = true;
    this.gtmService.postGtmEvent('form_step_complete', 'submit_your_vehicle_details', 3);
    if (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.planHolder) {
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.emailAddress = this.quotationService.quotationRequest.email;
    }
    setTimeout(() => this.loadingQuote = this.showSpinner ? true : false, 10000);
    this.quotationService.getQuote().subscribe((response: QuoteResponse) => {
      this.showSpinner = false;
      this.loadingQuote = false;

      const quoteValid = response.serviceResponseStatus === 'SUCCESS' && response.quoteList[0].totalPremiumAmt > 0 && response.quoteList[1].totalPremiumAmt > 0;
      this.quotationService.captureLicenseDetails = response.serviceResponseStatus === 'FAILED' && response.serviceErrorList[0].errorCode === this.licenseDetailsNotFoundErrorCd;
      this.quotationService.quoteInvalidOrIndicative = response.serviceResponseStatus === 'SUCCESS' &&
        (response.quoteList[0].statusCd === this.invalidQuoteStatusCd || response.quoteList[0].statusCd === this.indicativeQuoteStatusCd);
      this.quotationService.quoteResponse = response;

      if (quoteValid) {
        if (window.innerWidth > 767) {
          this.quotationService.quoteResponse.quoteList = [this.quotationService.quoteResponse.quoteList[1], this.quotationService.quoteResponse.quoteList[0]];
        }
        this.router.navigateByUrl('quote-step-three');
      } else if (this.quotationService.captureLicenseDetails) {
        this.formStart.nativeElement.scrollIntoView({behavior: 'smooth'});
      } else if (this.quotationService.quoteInvalidOrIndicative) {
        this.leadService.quoteDetail = this.getQuoteDetail();
        this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
        this.quotationService.error = true;
      } else {
        this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
        this.quotationService.error = true;
      }
    }, error => {
      this.showSpinner = false;
      this.quotationService.error = true;
    })
  }

  private getQuoteDetail(): string {
    return this.quotationService.quoteResponse.quoteList[0].quoteNo + ', ' + this.quotationService.quoteResponse.quoteList[0].plan.planDescr
      + ': R' + this.quotationService.quoteResponse.quoteList[0].totalPremiumAmt + 'pm | '
      + this.quotationService.quoteResponse.quoteList[1].quoteNo + ', ' + this.quotationService.quoteResponse.quoteList[1].plan.planDescr
      + ': R' + this.quotationService.quoteResponse.quoteList[1].totalPremiumAmt + 'pm';
  }

  fireAbandonmentTrackingEvent(fieldValue: string, fieldName: string) {
    if (fieldValue && !this._isAbandonmentTrackingFired(fieldName)) {
      this.gtmService.formName = 'insure_60_second_quote';
      this.gtmService.postGtmEvent('form_abandoned', fieldName, 2);
      this._setTrackingFiredOnField(fieldName);
    }

  }

  private _setTrackingFiredOnField(fieldName: string) {
    switch (fieldName) {
      case 'vin' : {
        this.gtmService.vinAbandonmentTrackingFired = true;
        break;
      }
      case 'registration' : {
        this.gtmService.registrationAbandonmentTrackingFired = true;
        break;
      }
    }
  }

  private _isAbandonmentTrackingFired(fieldName: string): boolean {
    switch (fieldName) {
      case 'vin' : return this.gtmService.vinAbandonmentTrackingFired;
      case 'registration' : return this.gtmService.registrationAbandonmentTrackingFired;
    }
  }

}

